<template>
  <main class="settings settings">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="setFirstCondition" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">登録情報</h2>
          <div class="label-link-area__main">
            <a href="javascript:void(0);" class="label-link">
              <span class="label-link__head">アカウント名</span>
              <span class="label-link__status"><input type="text" class="label-input-text" v-model="name_user"></span>
            </a>
            <a href="javascript:void(0);" class="label-link">
              <span class="label-link__head">メールアドレス</span>
              <span class="label-link__status">
                <input type="email" class="label-input-text" v-model="email">
              </span>
            </a>
            <a href="javascript:void(0);" class="label-link">
              <span class="label-link__head">パスワード</span>
              <span class="label-link__status">
                <input type="password" class="label-input-text label-input-text--password" v-model="password">
              </span>
            </a>
          </div>
        </section>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">TOEICの目標設定</h2>
          <div class="label-link-area__main">
            <a href="javascript:void(0);" class="label-link">
              <span class="label-link__head">目標スコア</span>
              <span class="label-link__status"><input type="number" class="label-input-text" v-model="target_score"></span>
            </a>
            <a href="javascript:void(0);" class="label-link">
              <span class="label-link__head">現状スコア</span>
              <span class="label-link__status"><input type="number" class="label-input-text" v-model="now_score"></span>
            </a>
          </div>
        </section>
        <section class="account-update-btn">
          <a href="javascript:void(0);" class="btn btn-square" @click="updateUserSettings">更新</a>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
  import Loading from '../common/Loading.vue';

  export default {
    title: 'アカウント情報変更 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'アカウント情報変更',
    description: 'abceed のアカウント情報変更はこちら',
    keywords: 'toeic,abceed,globee,アカウント',
    headerType: 'historyBackNotSearch',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        name_user: "",
        email: "",
        password: "",
        target_score: "",
        now_score: "",
        responseError: false
      }
    },
    created() {
      this.setFirstCondition();
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      }
    },
    methods: {
      setFirstCondition() {
        if (this.$store.getters.userSettings.user.name_user === "") {
          this.$store.dispatch("changeLoadingCondition", true);
          this.$store.dispatch('getUserSettings', {token:""})
            .then(data => {
              if (data === 'error') {
                this.responseError = true;
                this.$store.dispatch("changeLoadingCondition", false);
                return;
              }
              this.name_user = data.user.name_user;
              this.email = data.user.email;
              this.target_score = data.user.target_score;
              this.now_score = data.user.now_score;
              this.$store.dispatch("changeLoadingCondition", false);
            }).catch(() => {
              this.responseError = true;
              this.$store.dispatch("changeLoadingCondition", false);
            });
        } else {
          const userSettings = this.$store.getters.userSettings;
          this.name_user = userSettings.user.name_user;
          this.email = userSettings.user.email;
          this.target_score = userSettings.user.target_score;
          this.now_score = userSettings.user.now_score;
        }
      },
      updateUserSettings() {
        this.$store.dispatch("changeLoadingCondition", true);
        const userSettings = this.$store.getters.userSettings;
        let order = {
          name_user: this.name_user,
          target_score: this.target_score,
          now_score: this.now_score,
        };
        if (this.email !== userSettings.user.email) {
          order.email = this.email;
        }
        if (this.password) {
          order.password = this.password;
        }
        this.$store.dispatch('updateUserSettings', order)
          .then(data => {
            if (data.message) {
              switch (data.message) {
                case "email is invalid.":
                  alert("Emailが不正です");
                  break;
                case "password is too short.":
                  alert("パスワードが短すぎます");
                  break;
                case "this email already exists.":
                  alert("emailが既に他のユーザーに使われています");
                  break;
              }
              this.$store.dispatch("changeLoadingCondition", false);
              return false;
            }
            this.$router.push({name: 'settingHome'});
            this.$store.dispatch("changeLoadingCondition", false);
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/Account.vue